export type Retail360_Anticipated_Visits = "Retail360_Anticipated_Visits";
export type Retail360_Anticipated_Visits_Redesign = "Retail360_Anticipated_Visits_Redesign";

export type FlowId = Retail360_Anticipated_Visits | Retail360_Anticipated_Visits_Redesign;

export const flowId: FlowId = "Retail360_Anticipated_Visits_Redesign";
export type BillPageURL = "https://www.xfinity.com/bill-pay";
export type CancelServiceURL =
  "https://www.xfinity.com/xfinityassistant/?intent=other-style_retention-chat&refferer=hs_retention_chat";
export type CancelOverPhoneURL = "https://www.xfinity.com/support/cancel-service";
export type BereavementURL = "https://www.xfinity.com/support/account-management/bereavement";
export type CalculateSavingURL = "https://www.xfinity.com/mobile/learn/plan";
export type BusinessCustomerURL =
  "https://www02a.timetrade.com/app/comcast/workflows/comcast001/schedule/location?wfsid=29ua6msqogu5386mid9oevq1vvtu8r77&appointmentTypeGroupId=Appointments&appointmentTypeId=CBMobile_Appt&fs=1";

export type LinkType =
  | BillPageURL
  | CancelServiceURL
  | CancelOverPhoneURL
  | BereavementURL
  | CalculateSavingURL
  | BusinessCustomerURL;

export const billPageURL: LinkType = "https://www.xfinity.com/bill-pay";
export const cancelServiceURL: LinkType =
  "https://www.xfinity.com/xfinityassistant/?intent=other-style_retention-chat&refferer=hs_retention_chat";
export const cancelOverPhoneURL: LinkType = "https://www.xfinity.com/support/cancel-service";
export const bereavementURL: LinkType = "https://www.xfinity.com/support/account-management/bereavement";
export const calculateSavingURL: LinkType = "https://www.xfinity.com/mobile/learn/plan";
export const businessCustomerURL: LinkType =
  "https://www02a.timetrade.com/app/comcast/workflows/comcast001/schedule/location?wfsid=29ua6msqogu5386mid9oevq1vvtu8r77&appointmentTypeGroupId=Appointments&appointmentTypeId=CBMobile_Appt&fs=1";
